import {
  Form,
  Dialog,
  FormItem, 
  Row,
  Col,
  Button,
  Input,
  Option,
  Tooltip,
  Checkbox,
  Select,
} from 'element-ui'

const coms = [
  Row,
  Col,
  Form,
  FormItem,
  Button,
  Input,
  Option,
  Tooltip,
  Checkbox,
  Select,
  Dialog,
]

export default {
  install(Vue) {
    coms.map(com => {
      Vue.component(com.name,com)
    })
  }
}